import React from "react";
import { Heading } from "../../../../../../../../components/headers/heading/heading.component";
import { FlexItem, HeaderContent, HostContainer } from "./flyer-detail-page-header.styles";
import { FlyerDetailPageHeaderProps } from "./flyer-detail-page-header.props";
import { HeaderGlobals } from "../../../../../../../../components/headers/header-globals/header-globals.component";
import { BackButton } from "../../../../../../../../components/form-controls/button/back-button/back-button.component";
import { usePageTitle } from "../../../../../../../../features/navigation/types/pages.functions";
import { PAGES } from "../../../../../../../../features/navigation/types/pages.constant";

export const FlyerDetailPageHeader = (props: FlyerDetailPageHeaderProps) => {
  usePageTitle(`${PAGES.FLYERS.TITLE} - ${props.flyerName} - ${props.pageLabel}`);

  return (
    <HostContainer>
      <HeaderContent>
        <FlexItem>
          <BackButton />
          <Heading variant="primary">
            {props.flyerName} - {props.pageLabel}
          </Heading>
        </FlexItem>
        <FlexItem>
          <HeaderGlobals />
        </FlexItem>
      </HeaderContent>
    </HostContainer>
  );
};
